import { FC, ReactNode, useMemo } from 'react'
import Grid from '@mui/material/Grid'
import { Breakpoint } from '@mui/material'
import { toKeys } from '@util/object'
import useGlobalContext from '@context/GlobalContext/useGlobalContext'

export type SplitVals =
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6
  | 7
  | 8
  | 9
  | 10
  | 11
  | 12
  | number

type Split = Record<Breakpoint, SplitVals>
interface SplitScreenProps {
  split?: Split
  left: ReactNode
  right: ReactNode
}

const MAX_COL = 12
const SplitScreen: FC<SplitScreenProps> = ({
  split = { xs: 12, sm: 12, md: 12, lg: 5, xl: 5 },
  left,
  right,
}) => {
  const { pageHeight } = useGlobalContext()
  const rightSplit: Split = useMemo(
    () =>
      toKeys(split).reduce((acc, currentValue) => {
        const val = split[currentValue as Breakpoint]
        if (val) {
          acc[currentValue as Breakpoint] = MAX_COL - val || 12
        }
        return acc
      }, {} as Split),
    [split]
  )

  return (
    <Grid
      container
      sx={{
        minHeight: {
          xs: rightSplit.xs === 12 ? 'min-content' : pageHeight,
          sm: rightSplit.sm === 12 ? 'min-content' : pageHeight,
          md: rightSplit.md === 12 ? 'min-content' : pageHeight,
          lg: rightSplit.lg === 12 ? 'min-content' : pageHeight,
          xl: rightSplit.xl === 12 ? 'min-content' : pageHeight,
        },
        flexDirection: {
          xs: rightSplit.xs === 12 ? 'column-reverse' : 'row',
          sm: rightSplit.sm === 12 ? 'column-reverse' : 'row',
          md: rightSplit.md === 12 ? 'column-reverse' : 'row',
          lg: rightSplit.lg === 12 ? 'column-reverse' : 'row',
          xl: rightSplit.xl === 12 ? 'column-reverse' : 'row',
        },
      }}
    >
      <Grid
        item
        {...split}
        sx={({ ues }) => ({
          background: {
            xs: ues.primary['5'],
            sm: ues.primary['5'],
            md: ues.neutral['0'],
            lg: ues.neutral['0'],
            xl: ues.neutral['0'],
          },
          minHeight: '100%',
        })}
      >
        {left}
      </Grid>
      <Grid
        item
        {...rightSplit}
        sx={({ ues }) => ({ background: ues.primary['10'] })}
      >
        {right}
      </Grid>
    </Grid>
  )
}

export default SplitScreen
